







































































































import { Component, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class RiskSearch extends Vue {
  private word: string = this.$store.state.masterFieldState.searchText
  private sensorWord: string = this.$store.state.masterFieldState.searchSensorText

  @Prop() private count!: number

  private doMasterFieldSearch () {
    this.$store.commit('masterFieldState/setSearchText', this.word)
    this.$store.commit('masterFieldState/setSearchSensorText', this.sensorWord)

    this.$emit('search-list')
  }

  private doClear () {
    this.word = ''
    this.sensorWord = ''

    /* stateリセット */
    this.$store.commit('masterFieldState/setSearchText', this.word)
    this.$store.commit('masterFieldState/setSearchSensorText', this.sensorWord)

    this.$emit('reset-list')
  }
}
